import React, { Component, Fragment } from 'react';
import { observable, action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';
import classnames from 'classnames';
import withAppStore from 'decorators/withAppStore';
import inject from 'helpers/inject';

import Button from 'material-ui/Button';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'material-ui/Dialog';
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper';
import Typography from 'material-ui/Typography';
import TextField from 'material-ui/TextField';
import { InputLabel } from 'material-ui/Input';
import { MenuItem } from 'material-ui/Menu';
import { FormControl, FormHelperText } from 'material-ui/Form';
import Select from 'material-ui/Select';

import AuthService from 'services/auth';
import RouterService from 'services/router';

import getApiKeys from 'tasks/getApiKeys';

import styles from 'styles/components/WidgetCode';

@withStyles(styles)
@withAppStore
@observer
export default class WidgetCode extends Component {

  auth = inject(AuthService)
  router = inject(RouterService)

  @observable isOpen = false;
  @observable activeStep = 0;
  @observable apiKey = '';

  @computed
  get widgetSnippet() {
    const widgetAttributes = this.appStore.isTree ? this.treeWidgetAttributes : this.infoWidgetAttributes;
    return `<div ${this.commonAttributes}${widgetAttributes}></div>`;
  }

  @computed
  get commonAttributes() {
    return `
  data-widget-vendor="qborder"
  data-variant="${this.appStore.kind}"
  data-type="${this.appStore.type}"
  data-theme="${this.appStore.theme}"
  data-date="${this.appStore.date || null}"
  data-api-key="${this.apiKey}"
  data-dominant-mode="${this.appStore.dominantMode}"
  data-widget-id="${this.appStore.widgetId}"
  data-full-width="${this.appStore.fullWidth}"
  data-full-height="${this.appStore.fullHeight}"
`;
  }

  @computed
  get treeWidgetAttributes() {
    return `  data-info-code="${this.appStore.code || null}"
  data-dense="${this.appStore.dense}"
  data-search-term="${this.appStore.searchTerm || null}"
  data-search-open="${this.appStore.searchOpen}"
  data-close-type="${this.appStore.closeType}"
  data-disable-info="${this.appStore.disableInfo}"
`;
  }

  @computed
  get infoWidgetAttributes() {
    return `  data-show-title="${this.appStore.showTitle}"
  data-code="${this.appStore.code || null}"
  data-collapsed="${this.appStore.collapsed}"
`;
  }

  componentWillMount() {
    if (!getApiKeys.result.length)
      getApiKeys.perform()
  }

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <div className={ classes.root }>
          <Button
            fullWidth
            raised
            color='primary'
            className={ classes.text }
            onClick={ this.handleOpen }
          >
            Получить код виджета
          </Button>
        </div>
        <Dialog
          open={ this.isOpen }
          aria-labelledby="responsive-dialog-title"
          onClose={ this.handleClose }
        >
          <DialogTitle id="responsive-dialog-title">Установка виджета</DialogTitle>
          <DialogContent>

          <Stepper activeStep={ this.activeStep } orientation="vertical">

            <Step >
              <StepLabel>Укажите ключ API</StepLabel>
              <StepContent>
                <Typography>
                  Для работы виджета необходимо указать ключ API.
                </Typography>
                { this.auth.isAuthorized ? (
                  <FormControl fullWidth >
                    <InputLabel htmlFor="api-key-selector">Ключ API</InputLabel>
                    <Select
                      value={ this.apiKey }
                      onChange={ this.handleApiKeyChange }
                    >
                      <MenuItem value="">Не выбран</MenuItem>
                      { getApiKeys.result.map((key, index) => (
                        <MenuItem value={ key.key } key={ index } >
                          { key.domains }
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>Выберите ключ из списка имеющихся ключей</FormHelperText>
                  </FormControl>
                ) : (
                  <TextField
                    value={ this.apiKey }
                    onChange={ this.handleApiKeyChange }
                    label="Ключ API"
                    fullWidth
                    margin="normal"
                  />
                )}
                <div className={ classes.actionsContainer }>
                  <div>
                    <Button
                      raised
                      color="primary"
                      disabled={ !this.apiKey }
                      className={ classes.actionsButton }
                      onClick={ () => this.goToStep(1) }
                    >
                      Дальше
                    </Button>
                    { this.auth.isAuthorized ? (
                      <Button
                        color="primary"
                        onClick={ this.handleBuyKeyClick }
                      >
                        Купить новый ключ
                      </Button>
                    ) : (
                      <Button
                        color="primary"
                        onClick={ this.handleSignUpClick }
                      >
                        Войти, чтобы выбрать ключ
                      </Button>
                    )}
                  </div>
                </div>
              </StepContent>
            </Step>

            <Step >
              <StepLabel>Добавьте скрипт инициализации</StepLabel>
              <StepContent>
                <Typography paragraph>
                  Добавьте на Ваш сайт скрипт инициализации виджета:
                </Typography>
                <Typography component='pre' className={ classnames(classes.code, classes.preBlock) } paragraph >
                  {`
<script type="text/javascript"
  src="https://widgets.qborder.ru/bootstrap.js"
></script>
                  `}
                </Typography>
                <Typography paragraph>
                  Просто скопируйте код и вставьте его в конце страницы с виджетом, перед тегом <span className={ classes.code }>{'</body>'}</span>.
                </Typography>
                <Typography paragraph>
                  Скрипт может работать с несколькими виджетами на одной странице. Поэтому, если на странице уже есть другой виджет, повторно скрипт добавлять не нужно.
                </Typography>
                <div className={ classes.actionsContainer }>
                  <div>
                    <Button
                      raised
                      onClick={ () => this.goToStep(0) }
                      className={ classes.actionsButton }
                    >
                      Назад
                    </Button>
                    <Button
                      raised
                      color="primary"
                      onClick={ () => this.goToStep(2) }
                    >
                      Дальше
                    </Button>
                  </div>
                </div>
              </StepContent>
            </Step>

            <Step >
              <StepLabel>Добавьте элемент виджета</StepLabel>
              <StepContent>
                <Typography paragraph>
                  Добавьте на Ваш сайт блок-контейнер виджета:
                </Typography>
                <Typography component='pre' className={ classnames(classes.code, classes.preBlock) } paragraph >
                  { this.widgetSnippet }
                </Typography>
                <Typography paragraph>
                  Просто скопируйте код и вставьте его в то место на сайте, где хотите видеть виджет.
                </Typography>
                <div className={ classes.actionsContainer }>
                  <div>
                    <Button
                      raised
                      onClick={ () => this.goToStep(1) }
                      className={ classes.actionsButton }
                    >
                      Назад
                    </Button>
                    <Button
                      raised
                      color="primary"
                      onClick={ this.handleClose }
                    >
                      Готово
                    </Button>
                  </div>
                </div>
              </StepContent>
            </Step>

          </Stepper>

          </DialogContent>
          <DialogActions>
            <Button onClick={ this.handleClose } >
              Закрыть
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }

  @action.bound
  handleClose() {
    this.isOpen = false;
  }

  @action.bound
  handleOpen() {
    this.isOpen = true;
  }

  @action.bound
  goToStep(step = 0) {
    this.activeStep = step;
  }

  @action.bound
  handleSignUpClick() {
    this.router.transitionTo('/auth?login')
  }

  @action.bound
  handleBuyKeyClick() {
    this.router.transitionTo('/dashboard')
  }

  @action.bound
  handleApiKeyChange({ target: { value } }) {
    this.apiKey = value;
  }

}



// WEBPACK FOOTER //
// ./src/components/WidgetCode.js